(function() {

    'use strict';

    angular.module('Services').factory('TruckLoadInformationAuditTable', TruckLoadInformationAuditTable);

    TruckLoadInformationAuditTable.$inject = [
        'TruckInformationAuditService',
        'TableLiteFactory',
        'ConfirmationModalFactory',
        '$window',
        'toastr',
        '$rootScope',
        '$filter',
        '$routeParams',
        '$location'
    ];
    function TruckLoadInformationAuditTable(
        TruckInformationAuditService,
        TableLiteFactory,
        ConfirmationModalFactory,
        $window,
        toastr,
        $rootScope,
        $filter,
        $routeParams,
        $location
    ) {
        var paramId = $routeParams.driverId
      
        return function () {
            const viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.ftpImportNow.MESSAGE',
                code: 'messages.warning.ftpImportNow.CODE',
            });
            var tableData = {
                tableName: 'TruckLoadInformationAuditTable',
               
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '135px'
                },
                headers: [{
                    label: "Date",
                    viewName: "createdDateFormatted",
                    filterName: "createdDateFormatted",
                    filter: {
                        type: 'datePicker',
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: "Consignment No.",
                    viewName: "consignmentNo",
                    filterName: "consignmentNo",
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: "Manifest No.",
                    viewName: "manifestNo",
                    filterName: "manifestNo",
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: "Scanned packages",
                    viewName: "containerCode",
                    filterName: "containerCode",
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: "Company",
                    viewName: "company",
                    filterName: "company",
                    /*filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },*/
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Office/Location',
                    viewName: 'officeLocation',
                    filterName: 'officeLocation',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Account',
                    viewName: 'account',
                    filterName: 'account',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Booking Status',
                    viewName: 'bookingStatus',
                    filterName: 'bookingStatus',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Tracking No.',
                    viewName: 'trackingNo',
                    filterName: 'trackingNo',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: 'Third Party Reference No.',
                    viewName: 'thirdPartyReferenceNo',
                    filterName: 'thirdPartyReferenceNo',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: 'Customer Ref No.',
                    viewName: 'customerRefNo',
                    filterName: 'customerRefNo',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: 'Link Job',
                    viewName: 'linkedJob',
                    filterName: 'linkedJob',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: 'Source Address',
                    viewName: 'sourceAdd',
                    // filterName: 'sourceAdd',
                    // headerFn: function () {
                    //     sort(this.filterName);
                    // }
                },{
                    label: 'Destination Address',
                    viewName: 'destinationAdd',
                    // filterName: 'destinationAdd',
                    // headerFn: function () {
                    //     sort(this.filterName);
                    // }
                },{
                    label: 'Amount Ex Tax',
                    viewName: 'AmountExTax',
                    filterName: 'AmountExTax',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                rowOnClick: rowClick,
                data: []
            };

            function rowClick(id){
                $location.path('/shipments/view/' +id)
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: TruckInformationAuditService.getTruckLoadInformationAudit,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        const truckload = TruckInformationAuditService.truckLoadInfomationAuditData(data)
                        buildTableData(truckload);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    const date = new Date(item.createdDate);
                    const timeZone = date.toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
                    const dateFormatted = $filter('bbaDate')(item.createdDate);
                    const hour = date.getHours();
                    const min = date.getMinutes();
                    item.createdDateFormatted = `${dateFormatted}`;
                    item.importStatusFormatted = `${item.imported} IMPORTED, ${item.failed} FAILED`;
                    item.commentsFormatted = item.comments || 'N/A';
                    if (item.sourceAddress) {
                        item.sourceAdd = {
                            type: 'multiLine',
                            list: [
                                item.sourceAddress.addressLine1 || undefined,
                                item.sourceAddress.addressLine2 || undefined,
                            ]
                        };
                        const loc = item.sourceAddress.location;
                        if (loc) {
                            item.sourceAdd.list = item.sourceAdd.list.concat([
                                loc.name + (loc.state ? ', ' + loc.state.code : '') + ' ' + loc.code,
                                angular.getObjVal(loc, 'country.name')
                            ]);
                        }
                    } else {
                        item.sourceAdd = 'N/A';
                    }
                    if (item.destinationAddress) {
                        item.destinationAdd = {
                            type: 'multiLine',
                            list: [
                                item.destinationAddress.addressLine1 || undefined,
                                item.destinationAddress.addressLine2 || undefined,
                            ]
                        };
                        const loc = item.destinationAddress.location;
                        if (loc) {
                            item.destinationAdd.list = item.destinationAdd.list.concat([
                                loc.name + (loc.state ? ', ' + loc.state.code : '') + ' ' + loc.code,
                                angular.getObjVal(loc, 'country.name')
                            ]);
                        }
                    }
                    if(item.containerCodes.length){
                        item.containerCode ={
                            type:'multiLine',
                            list:item.containerCodes || undefined
                        }
                    }else{
                        item.containerCode = 'N/A';
                    }

                    item.href = '/shipments/view/' + item.shipmentId;
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View shipments',
                            class: 'btn btn-primary',
                            action: row => {
                                
                            }
                        }, {
                            text: 'View manifest',
                            class: 'btn btn-primary',
                            action: row => {

                            }
                        }]
                    };
                    tableData.data.push(item);
                });
            };
            this.tableData = tableData;
        };
    }

})();




// WEBPACK FOOTER //
// ./js/services/tables/manifests/TruckLoadInformationAuditTable .js